import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

export default function TermsPage() {
  return (
    <div style={{ minHeight: "100vh", background: "#000000", color: "rgba(255,255,255,0.9)" }}>
      <div style={{ maxWidth: 720, margin: "0 auto", padding: "48px 24px 80px" }}>
        <Link
          to="/"
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 6,
            fontSize: 14,
            color: "rgba(255,255,255,0.4)",
            textDecoration: "none",
            marginBottom: 40,
          }}
          onMouseEnter={e => (e.currentTarget.style.color = "rgba(255,255,255,0.9)")}
          onMouseLeave={e => (e.currentTarget.style.color = "rgba(255,255,255,0.4)")}
        >
          <ArrowLeft size={14} /> Back to homepage
        </Link>

        <h1 style={{ fontSize: 28, fontWeight: 700, marginBottom: 6, color: "#ffffff" }}>
          Terms of Service
        </h1>
        <p style={{ fontSize: 13, color: "rgba(255,255,255,0.4)", marginBottom: 16 }}>
          Last updated: 1 July 2026
        </p>

        {/* TODO (post sole-trader registration): replace with the registered trading name
            and a correspondence address. UK Consumer Contracts Regulations require the
            trader's identity and a geographic address to be provided. */}
        <p style={{ fontSize: 13, color: "rgba(255,255,255,0.55)", marginBottom: 48, lineHeight: 1.6 }}>
          Margin Metrics is a service operated by its founder as a sole trader based in the
          United Kingdom. For our full trading name and a correspondence address, contact{" "}
          <a href="mailto:margin.store26@gmail.com" style={{ color: "#1d9e75" }}>
            margin.store26@gmail.com
          </a>.
        </p>

        <div style={{ display: "flex", flexDirection: "column", gap: 0 }}>
          <Section title="1. Acceptance of Terms">
            <p>
              By accessing or using Margin Metrics (&ldquo;the Platform&rdquo;), you agree to be bound
              by these Terms of Service. If you do not agree, you must not use the Platform.
            </p>
          </Section>

          <Section title="2. Informational Service Only — Not Financial Advice">
            <p>
              Margin Metrics is a trading performance tracking and analytics platform. All content
              provided by the Platform — including AI-generated insights, trade analysis, risk alerts,
              coaching suggestions, and market commentary — is{" "}
              <Strong>for informational and educational purposes only</Strong>.
            </p>
            <p>
              Nothing on the Platform constitutes financial advice, investment advice, or a
              recommendation to buy or sell any financial instrument. You are solely responsible for your
              own trading decisions and their outcomes. Always seek independent financial advice if
              required.
            </p>
          </Section>

          <Section title="3. User Responsibility">
            <p>
              You acknowledge that trading financial instruments carries a significant risk of loss. The
              Platform does not guarantee profitable trading outcomes. Any losses incurred as a result of
              trading decisions made using information from this Platform are entirely your own
              responsibility.
            </p>
          </Section>

          <Section title="4. Account Registration">
            <p>
              You must provide accurate information when creating an account. You are responsible for
              maintaining the confidentiality of your credentials and for all activity that occurs under
              your account.
            </p>
          </Section>

          <Section title="5. Acceptable Use">
            <p>You agree not to:</p>
            <ul>
              <li>Reverse-engineer, decompile, or copy any part of the Platform.</li>
              <li>Use automated tools to scrape, crawl, or extract data from the Platform.</li>
              <li>Attempt to gain unauthorised access to any part of the Platform or its infrastructure.</li>
              <li>Use the Platform for any unlawful purpose or in violation of applicable regulations.</li>
              <li>Harass, abuse, or harm other users.</li>
            </ul>
          </Section>

          <Section title="6. Account Suspension and Termination">
            <p>
              We reserve the right to suspend or permanently terminate your account at any time, without
              prior notice, if we determine in our sole discretion that you have violated these Terms,
              engaged in abusive behaviour, or posed a risk to the Platform or other users. You may
              delete your own account at any time through Settings.
            </p>
          </Section>

          <Section title="7. Subscriptions and Payments">
            <p>
              Certain features require a paid subscription. Subscriptions renew automatically on a
              monthly or annual basis unless cancelled before the renewal date. You can cancel at any
              time from the billing portal in Settings; cancellation stops future renewals and you keep
              access until the end of the current billing period.
            </p>
            <p>
              <Strong>14-day cancellation right:</Strong> If you are a consumer in the UK or EU, you have
              the right to cancel a new subscription within 14 days of purchase under the Consumer
              Contracts Regulations 2013. Because the Platform is digital content supplied immediately,
              by subscribing and starting to use paid features you acknowledge that you request immediate
              access and accept that your 14-day right to cancel is lost once the service has been fully
              performed. Where the right still applies, contact us for a refund of the current period.
            </p>
            <p>
              For any billing questions or refund requests, contact us at{" "}
              <a
                href="mailto:margin.store26@gmail.com"
                style={{ color: "#1d9e75", textDecoration: "none" }}
              >
                margin.store26@gmail.com
              </a>
              .
            </p>
          </Section>

          <Section title="8. Intellectual Property">
            <p>
              You retain full ownership of all trade data and content you submit to the Platform. The
              Platform itself, including its design, code, and AI systems, is the intellectual property
              of Margin Metrics. You may not reproduce, distribute, or create derivative works from any
              part of the Platform without explicit written permission.
            </p>
          </Section>

          <Section title="9. Limitation of Liability">
            <p>
              The Platform is provided &ldquo;as is&rdquo; without warranties of any kind, express or
              implied. To the fullest extent permitted by law, Margin Metrics shall not be liable for any
              indirect, incidental, special, or consequential damages arising from your use of the
              Platform, including but not limited to trading losses, loss of data, or loss of profits.
            </p>
          </Section>

          <Section title="10. Governing Law">
            <p>
              These Terms are governed by and construed in accordance with the laws of{" "}
              <Strong>England and Wales</Strong>. Any disputes arising under or in connection with these
              Terms shall be subject to the exclusive jurisdiction of the courts of England and Wales.
            </p>
          </Section>

          <Section title="11. Changes to These Terms">
            <p>
              We may update these Terms from time to time. We will provide notice of material changes via
              in-app notification or email. Continued use of the Platform after the effective date of any
              changes constitutes acceptance of the revised Terms.
            </p>
          </Section>

          <Section title="12. Contact">
            <p>
              For questions about these Terms, contact us at{" "}
              <a
                href="mailto:margin.store26@gmail.com"
                style={{ color: "#1d9e75", textDecoration: "none" }}
              >
                margin.store26@gmail.com
              </a>
              .
            </p>
          </Section>
        </div>
      </div>
    </div>
  );
}

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div style={{ borderTop: "1px solid rgba(255,255,255,0.06)", paddingTop: 28, paddingBottom: 28 }}>
      <h2 style={{ fontSize: 16, fontWeight: 600, color: "#ffffff", marginBottom: 14 }}>{title}</h2>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 10,
          fontSize: 14,
          lineHeight: 1.7,
          color: "rgba(255,255,255,0.5)",
        }}
      >
        {children}
      </div>
    </div>
  );
}

function Strong({ children }: { children: React.ReactNode }) {
  return <strong style={{ color: "rgba(255,255,255,0.8)", fontWeight: 600 }}>{children}</strong>;
}
